/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ブックマークが登録されたときのビューを識別する文字列
 * @export
 * @enum {string}
 */

export const BookmarkViewTypeEnumWeb = {
    Web: 'web'
} as const;

export type BookmarkViewTypeEnumWeb = typeof BookmarkViewTypeEnumWeb[keyof typeof BookmarkViewTypeEnumWeb];



